import Vue from 'vue';
import { Prop, Component, Watch } from 'vue-property-decorator';
import { ContentItem } from '@gnb/components/Common';

@Component({
    components: {
        ContentItem
    }
})
export default class PersonalInfoView  extends Vue {   
    @Prop({ type: Object }) personalInfo!: kyobobook.PersonalInfo;

    photoPath: string = '';
    officeTel: string = '';
    mobileTel: string = '';
    jobRoleName: string = '';

    get photoUrl(){
        if(this.personalInfo.photoPath && this.personalInfo.photoPath != ""){
            return this.personalInfo.photoPath;
        } else {
            return "/cm/gres/faux/images/ghost.png";
        }
    }

    @Watch('personalInfo')
    onInfoChanged(newVal: kyobobook.PersonalInfo) {
        this.photoPath = newVal.photoPath;
        this.officeTel = newVal.officeTel ?? '';
        this.mobileTel = newVal.mobileTel ?? '';
        this.jobRoleName = newVal.jobRoleName ?? '';
    }

    created() {
        this.onInfoChanged(this.personalInfo);
    }

    getInfo() {
        return <kyobobook.PersonalInfo> {
            officeTel: this.officeTel,
            mobileTel: this.mobileTel,
            jobRoleName: this.jobRoleName,
            officeAddress: '',
            photoPath: ''
        };
    }
}